// Условия списка пользователей в адресе страницы: поиск, роль, состояние, сортировка.
// 040 (FR-018): «Роль» — вид пользователя: «Администратор», «Сотрудник», «Внешний»,
// «Сопровождение» (userKinds); в запрос списка она уходит полем kind.
import { userKinds, userSortFields, userStates } from '@kp/contracts';
import type { SortValue, UserKind, UserState } from '@kp/contracts';

export type UserSortField = (typeof userSortFields)[number];
export type UserSort = SortValue<UserSortField>;

export interface UsersSearch {
  q?: string;
  role?: UserKind;
  state?: UserState;
  sort?: UserSort;
}

const sortValues = userSortFields.flatMap((field) => [field, `-${field}`]) as UserSort[];

export function isUserKind(value: unknown): value is UserKind {
  return typeof value === 'string' && (userKinds as readonly string[]).includes(value);
}

export function parseUsersSearch(search: Record<string, unknown>): UsersSearch {
  const result: UsersSearch = {};
  if (typeof search.q === 'string' && search.q.trim() !== '') result.q = search.q;
  // Старые ссылки с ролью до 040 (role=controller) — без условия.
  if (isUserKind(search.role)) result.role = search.role;
  if (
    typeof search.state === 'string' &&
    (userStates as readonly string[]).includes(search.state)
  ) {
    result.state = search.state as UserState;
  }
  if (typeof search.sort === 'string' && (sortValues as readonly string[]).includes(search.sort)) {
    result.sort = search.sort as UserSort;
  }
  return result;
}

export function hasFilters(search: UsersSearch): boolean {
  return Boolean(search.q || search.role || search.state);
}

export const userSortLabels = {
  fullName: 'ФИО',
  email: 'Почта',
  createdAt: 'Дата создания',
} as const satisfies Record<UserSortField, string>;
